export default "__VITE_ASSET__DEKTA9TP__"